import { isNil } from 'lodash-es';

function makeKey(coords) {
  if (!coords) return '';
  return `${coords.lat}-${coords.lng}`;
}

export function makeMarker(coords, otherProps) {
  return {
    key: makeKey(coords),
    coords,
    ...otherProps,
  };
}

function isValidPath(path) {
  return path.every(point => point && !isNil(point.lat) && !isNil(point.lng));
}

export function makePolyline(path, otherProps) {
  if (isValidPath(path)) {
    return { key: path.map(makeKey).join(','), path, ...otherProps };
  }

  return null;
}
